import React from 'react'
import PropTypes from 'prop-types'

import Careers from './JobsV3'
import MLSWaitlistForm from './MLSWaitlistForm'

function HardCoded({ data }) {
  const { option } = data
  if (option === 'Careers') {
    return <Careers />
  }
  if (option === 'MLS Waitlist Form') {
    return <MLSWaitlistForm />
  }

  return null
}

HardCoded.propTypes = {
  data: PropTypes.object.isRequired
}

export default HardCoded
